module.exports = __webpack_public_path__ + "img/transfer_endOrder.ea177c63.svg";